/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
/** Каталог модулей KIN DIGITAL CRM+ v 8.0 (раздел 3 ТЗ). */
export type Edition = 'BASE' | 'LAWYER' | 'BANKRUPTCY';

export interface ModuleInfo {
  code: string;
  name: string;
  /** В какой редакции модуль входит по умолчанию; 'AI' и 'ADDON' продаются отдельно */
  edition: Edition | 'AI' | 'ADDON';
}

export const MODULES: ModuleInfo[] = [
  { code: 'M01', name: 'Клиенты и контакты', edition: 'BASE' },
  { code: 'M02', name: 'Лиды и воронки продаж', edition: 'BASE' },
  { code: 'M03', name: 'Управление договорами', edition: 'BASE' },
  { code: 'M04', name: 'Производственные затраты', edition: 'BASE' },
  { code: 'M05', name: 'Расходы', edition: 'BASE' },
  { code: 'M06', name: 'Контрагенты', edition: 'BASE' },
  { code: 'M07', name: 'Справочники и настраиваемые поля', edition: 'BASE' },
  { code: 'M08', name: 'Задачи, календарь, проекты', edition: 'BASE' },
  { code: 'M09', name: 'Документы и архив', edition: 'BASE' },
  { code: 'M10', name: 'Отчётность и аналитика', edition: 'BASE' },
  { code: 'M11', name: 'Дебиторская задолженность', edition: 'LAWYER' },
  { code: 'M12', name: 'Судебное делопроизводство', edition: 'LAWYER' },
  { code: 'M13', name: 'ЭДО с электронной подписью', edition: 'LAWYER' },
  { code: 'M14', name: 'Процедуры банкротства и рабочее место АУ', edition: 'BANKRUPTCY' },
  { code: 'M15', name: 'Анализ финансового состояния должников', edition: 'BANKRUPTCY' },
  { code: 'M16', name: 'Электронные торги', edition: 'BANKRUPTCY' },
  { code: 'M17', name: 'Исполнительное производство', edition: 'LAWYER' },
  { code: 'M18', name: 'Клиентский портал', edition: 'LAWYER' },
  { code: 'M19', name: 'ИИ-скоринг клиентов и должников', edition: 'AI' },
  { code: 'M20', name: 'ИИ-ассистент юриста', edition: 'AI' },
  { code: 'M21', name: 'ИИ-аналитика судебных процессов', edition: 'AI' },
  { code: 'M22', name: 'ИИ-чат-бот для клиентов', edition: 'AI' },
  { code: 'M23', name: 'ИИ-оптимизация работы с должниками', edition: 'AI' },
  { code: 'M24', name: 'ИИ-сопровождение исполнительного производства', edition: 'AI' },
  { code: 'M25', name: 'SMS-информирование', edition: 'ADDON' },
  { code: 'M26', name: 'Мобильное приложение сотрудника', edition: 'ADDON' },
  { code: 'M27', name: 'Адаптация приложения под фирменный стиль', edition: 'ADDON' },
  { code: 'M28', name: '«Мобильный Юрист»', edition: 'ADDON' },
  { code: 'M29', name: 'Распознавание текста и извлечение данных', edition: 'AI' },
  { code: 'M30', name: 'Распознавание речи', edition: 'AI' },
  { code: 'M31', name: '«Чат с делом» и поиск по смыслу', edition: 'AI' },
  { code: 'M32', name: 'ИИ-агенты и делегирование действий', edition: 'AI' },
  { code: 'M33', name: 'Телефония и речевая аналитика', edition: 'BASE' },
  { code: 'M34', name: 'Омниканальные коммуникации', edition: 'BASE' },
  { code: 'M35', name: 'Учёт времени, биллинг и платежи', edition: 'LAWYER' },
  { code: 'M36', name: 'Конструктор документов и шаблонов', edition: 'BASE' },
  { code: 'M37', name: 'Конструктор процессов и автоматизаций', edition: 'BASE' },
  { code: 'M38', name: 'Онлайн-формы и приём обращений', edition: 'BASE' },
  { code: 'M39', name: 'Подписание документов клиентом', edition: 'LAWYER' },
  { code: 'M40', name: 'Контроль процессуальных сроков', edition: 'LAWYER' },
  { code: 'M41', name: 'Мониторинг внешних реестров', edition: 'LAWYER' },
  { code: 'M42', name: 'BI-конструктор дашбордов', edition: 'BASE' },
];

const EDITION_ORDER: Edition[] = ['BASE', 'LAWYER', 'BANKRUPTCY'];

/** Модули, входящие в редакцию (с учётом вложенности Базовая < Юрист < Банкротство). */
export function modulesOfEdition(edition: Edition): string[] {
  const level = EDITION_ORDER.indexOf(edition);
  return MODULES.filter((m) => {
    const i = EDITION_ORDER.indexOf(m.edition as Edition);
    return i >= 0 && i <= level;
  }).map((m) => m.code);
}

export const AI_PACKAGE: string[] = MODULES.filter((m) => m.edition === 'AI').map((m) => m.code);
export const CORE_MODULES = ['M01', 'M02', 'M03', 'M04', 'M05', 'M06', 'M07', 'M08', 'M09', 'M10'];
